<div class="row mb-2">
  <div class="col-md-2">
    <select [(ngModel)]="searchBy" class="form-control">
      <option value="">Select Search By</option>
      <option value="userID">User ID</option>
      <option value="firstName">Name</option>
      <option value="phoneNumber">Mobile</option>
      <option value="emailId">Email</option>
      <option value="city">City</option>
    </select>
  </div>
  <div class="col-md-2">
    <input
      type="search"
      [(ngModel)]="searchText"
      class="form-control mb-2"
      placeholder="Search Text"
    />
  </div>
  <div class="col-md-2">
    <button
      (click)="search()"
      class="btn btn-primary btn-block"
      [disabled]="searchBy == ''"
    >
      Search <i class="fa fa-search"></i>
    </button>
  </div>

  <div class="col-md-6 m-0 text-end">
    <button
      (click)="exportToExcel()"
      style="margin: 0px 5px !important"
      class="btn-shadow d-inline-flex align-items-center btn btn-success"
    >
      <i class="fa fa-file-excel-o" aria-hidden="true"></i> Export Current Excel
    </button>
    <div class="dropdown d-inline-flex align-items-center">
      <a
        class="btn-shadow dropdown-toggle btn btn-success"
        type="button"
        data-bs-toggle="dropdown"
      >
        <i class="fa fa-file-excel-o" aria-hidden="true"></i> Export All Excel
      </a>
      <ul class="dropdown-menu m-0 p-0">
        <li>
          <button
            class="dropdown-item"
            type="button"
            (click)="getAllUsers(totalItems, 0)"
          >
            Active Users
          </button>
        </li>
        <li>
          <button
            class="dropdown-item"
            type="button"
            (click)="getAllUsers(totalDeltedItems, 1)"
          >
            Deleted Users
          </button>
        </li>
      </ul>
    </div>
  </div>
</div>

<div>
  <div class="card-header font-weight-B fs-1r">All Users</div>
  <nav>
    <div class="nav nav-tabs" id="nav-tab" role="tablist">
      <button
        class="nav-link active"
        id="nav-home-tab"
        data-bs-toggle="tab"
        data-bs-target="#userActive"
        type="button"
        role="tab"
        aria-controls="userActive"
        aria-selected="true"
      >
        <i class="fa fa-clock-o" aria-hidden="true" (click)="getUsers()"></i>
        Active Users
        <input
          class="text-center text-primary border border-primary rounded"
          style="width: 40px"
          disabled
          [ngModel]="totalItems"
        />
      </button>

      <button
        class="nav-link"
        id="nav-profile-tab"
        data-bs-toggle="tab"
        data-bs-target="#userDeleted"
        type="button"
        role="tab"
        aria-controls="userDeleted"
        aria-selected="false"
      >
        <i
          class="fa fa-trash"
          aria-hidden="true"
          (click)="getDeletedUsers()"
        ></i>
        Deleted Users
        <input
          class="text-center text-primary border border-primary rounded"
          style="width: 30px"
          disabled
          [ngModel]="totalDeltedItems"
        />
      </button>
    </div>
  </nav>

  <div class="tab-content" id="nav-tabContent">
    <div
      class="tab-pane fade show active"
      id="userActive"
      role="tabpanel"
      aria-labelledby="pending-tab"
    >
      <div class="table-responsive">
        <table
          class="align-middle mb-0 table table-borderless table-striped table-hover"
          id="excel-table"
        >
          <thead>
            <tr>
              <th class="w-15">Name</th>
              <th>Mobile No.</th>
              <th>Email</th>
              <th>User Type</th>
              <th>City</th>
              <th>Created On</th>
              <th class="text-end">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let data of allUsersList
                 
              "
            >
            <!-- | paginate
            : {
                itemsPerPage: itemsPerPage,
                currentPage: page,
                totalItems: totalItems
              } -->
              <td class="w-15">
                <div class="widget-content p-0">
                  <div class="widget-content-wrapper">
                    <div class="widget-content-left flex2">
                      <div class="widget-heading">
                        {{ data.firstName }} {{ data.lastName }}
                      </div>
                    </div>
                  </div>
                </div>
              </td>

              <td>
                <div class="widget-content p-0">
                  <div class="widget-content-wrapper">
                    <div class="widget-content-left flex2">
                      <div class="widget-heading">{{ data.phoneNumber }}</div>
                    </div>
                  </div>
                </div>
              </td>
              <td>
                <div class="widget-content p-0">
                  <div class="widget-content-wrapper">
                    <div class="widget-content-left flex2">
                      <div class="widget-heading">{{ data.emailId }}</div>
                    </div>
                  </div>
                </div>
              </td>

              <td>
                <div class="widget-content p-0">
                  <div class="widget-content-wrapper">
                    <div class="widget-content-left flex2">
                      <div class="widget-heading">{{ data.userType }}</div>
                    </div>
                  </div>
                </div>
              </td>

              <td>
                <div class="widget-content p-0">
                  <div class="widget-content-wrapper">
                    <div class="widget-content-left flex2">
                      <div class="widget-heading">{{ data.city }}</div>
                    </div>
                  </div>
                </div>
              </td>

              <td>
                <div class="widget-content p-0">
                  <div class="widget-content-wrapper">
                    <div class="widget-content-left flex2">
                      <div class="widget-heading">
                        {{
                          data.createdOnTS * 1000
                            | date : "dd MMM yyyy, hh:mm a" : "UTC+5:30"
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </td>

              <td class="text-end">
                <div class="dropdown">
                  <button
                    class="btn btn-info dropdown-toggle"
                    type="button"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Action
                  </button>
                  <ul
                    class="dropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                  >
                   <li>
                      <a
                        class="dropdown-item"
                        (click)="routeWalletDetails(data)"
                        >Wallet <i class="fa fa-eye"></i
                      ></a>
                    </li>   
                    <li>
                      <a class="dropdown-item" (click)="routeViewDetails(data)"
                        >View Details <i class="fa fa-eye"></i
                      ></a>
                    </li>
                    <li>
                      <a
                        class="dropdown-item"
                        (click)="editUser(content1, data)"
                        >Edit <i class="fa fa-pencil"></i
                      ></a>
                    </li>
                    <li>
                      <a class="dropdown-item" (click)="deleteUser(data)"
                        >Delete <i class="fa fa-trash"></i
                      ></a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
          <div *ngIf="allUsersList?.length == 0" class="text-center mt-5 mb-5">
            <span class="text-danger">Data Not found</span>
          </div>
        </table>
        <!-- <pagination-controls
          class="my-pagination"
          (pageChange)="gty((page = $event))"
        ></pagination-controls> -->

        <!-- <ngb-pagination 
        (pageChange)="gty(page=$event)" 
        [collectionSize]="totalItems" 
        [(page)]="page" 
        [pageSize]="itemsPerPage" 
        [maxSize]="3" 
        [rotate]="true" 
        [boundaryLinks]="false">
        </ngb-pagination> -->

        <ngb-pagination 
          (pageChange)="gty(active_Page = $event)" 
          [collectionSize]="totalItems" 
          [(page)]="active_Page" 
          [pageSize]="itemsPerPage" 
          [maxSize]="3" 
          [rotate]="true" 
          [boundaryLinks]="false">
      </ngb-pagination> 
    
      </div>
    </div>

    <div
      class="tab-pane fade"
      id="userDeleted"
      role="tabpanel"
      aria-labelledby="userDeleted"
    >
      <div class="table-responsive">
        <table
          class="align-middle mb-0 table table-borderless table-striped table-hover"
          id="excel-table"
        >
          <thead>
            <tr>
              <th class="w-15">Name</th>
              <th>Mobile No.</th>
              <th>Email</th>
              <th>User Type</th>
              <th>City</th>
              <th>Created On</th>
              <th class="text-end">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let data of allDeletedUsersList
              "
            >
            <!-- | paginate
                    : {
                        itemsPerPage: itemsPerPage,
                        currentPage: page,
                        totalDeletedItems: totalDeltedItems
                      } -->
              <td class="w-15">
                <div class="widget-content p-0">
                  <div class="widget-content-wrapper">
                    <div class="widget-content-left flex2">
                      <div class="widget-heading">
                        {{ data.firstName }} {{ data.lastName }}
                      </div>
                    </div>
                  </div>
                </div>
              </td>

              <td>
                <div class="widget-content p-0">
                  <div class="widget-content-wrapper">
                    <div class="widget-content-left flex2">
                      <div class="widget-heading">{{ data.phoneNumber }}</div>
                    </div>
                  </div>
                </div>
              </td>
              <td>
                <div class="widget-content p-0">
                  <div class="widget-content-wrapper">
                    <div class="widget-content-left flex2">
                      <div class="widget-heading">{{ data.emailId }}</div>
                    </div>
                  </div>
                </div>
              </td>

              <td>
                <div class="widget-content p-0">
                  <div class="widget-content-wrapper">
                    <div class="widget-content-left flex2">
                      <div class="widget-heading">{{ data.userType }}</div>
                    </div>
                  </div>
                </div>
              </td>

              <td>
                <div class="widget-content p-0">
                  <div class="widget-content-wrapper">
                    <div class="widget-content-left flex2">
                      <div class="widget-heading">{{ data.city }}</div>
                    </div>
                  </div>
                </div>
              </td>

              <td>
                <div class="widget-content p-0">
                  <div class="widget-content-wrapper">
                    <div class="widget-content-left flex2">
                      <div class="widget-heading">
                        {{
                          data.createdOnTS * 1000
                            | date : "dd MMM yyyy, hh:mm a" : "UTC+5:30"
                        }}
                      </div>
                    </div>
                  </div>
                </div>
              </td>

              <td class="text-end">
                <div class="dropdown">
                  <button
                    class="btn btn-info dropdown-toggle"
                    type="button"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Action
                  </button>
                  <ul
                    class="dropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li>
                      <a class="dropdown-item" (click)="routeViewDetails(data)"
                        >View Details <i class="fa fa-eye"></i
                      ></a>
                    </li>
                    <li>
                      <a
                        class="dropdown-item"
                        (click)="editUser(content1, data)"
                        >Edit <i class="fa fa-pencil"></i
                      ></a>
                    </li>
                    <li>
                      <a class="dropdown-item" (click)="deleteUser(data)"
                        >Delete <i class="fa fa-trash"></i
                      ></a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
          <div
            *ngIf="allDeletedUsersList?.length == 0"
            class="text-center mt-5 mb-5"
          >
            <span class="text-danger">Data Not found</span>
          </div>
        </table>
        <!-- <pagination-controls
          class="my-pagination"
          (pageChange)="gty_del((page = $event))"
        ></pagination-controls> -->

        <ngb-pagination 
        (pageChange)="gty_del(deleted_page = $event)" 
        [collectionSize]="totalDeltedItems" 
        [(page)]="deleted_page" 
        [pageSize]="itemsPerPage" 
        [maxSize]="3" 
        [rotate]="true" 
        [boundaryLinks]="false">
    </ngb-pagination> 
      </div>
    </div>
  </div>
</div>

<div class="card-body">
  <ng-template #content1 let-c="close" let-d="dismiss">
    <div class="modal-header">
      <h4 class="modal-title">
        <i class="fa fa-pencil" aria-hidden="true"></i> Edit User
      </h4>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="d('Cross click')"
      ></button>
    </div>
    <div class="modal-body">
      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-4">
          <label for="">Id </label>
          <input
            type="text"
            [(ngModel)]="adminId"
            placeholder="Enter id"
            class="form-control"
            readonly
          />
        </div>
        <div class="col-md-4">
          <label for="">User Id </label>
          <input
            type="text"
            [(ngModel)]="userId"
            placeholder="Enter user id"
            class="form-control"
            readonly
          />
        </div>
        <div class="col-md-2"></div>
      </div>

      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-4">
          <label for="">First Name </label>
          <input
            type="text"
            [(ngModel)]="adminFName"
            placeholder="Enter first name"
            class="form-control"
          />
        </div>
        <div class="col-md-4">
          <label for="">Last Name </label>
          <input
            type="text"
            [(ngModel)]="adminLName"
            placeholder="Enter last name"
            class="form-control"
          />
        </div>
        <div class="col-md-2"></div>
      </div>

      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-4">
          <label for="">Address </label>
          <input
            type="text"
            [(ngModel)]="adminAddress"
            placeholder="Enter address"
            class="form-control"
          />
        </div>
        <div class="col-md-4">
          <label for="">City </label>
          <input
            type="text"
            [(ngModel)]="adminCity"
            placeholder="Enter city"
            class="form-control"
          />
        </div>
        <div class="col-md-2"></div>
      </div>

      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-4">
          <label for="">Pincode </label>
          <input
            type="text"
            [(ngModel)]="adminPincode"
            placeholder="Enter pincode"
            class="form-control"
          />
        </div>
        <div class="col-md-4">
          <label for="">State </label>
          <input
            type="text"
            [(ngModel)]="adminState"
            placeholder="Enter state"
            class="form-control"
          />
        </div>
        <div class="col-md-2"></div>
      </div>

      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-4">
          <label for="">Phone No. </label>
          <input
            type="text"
            [(ngModel)]="adminPhone"
            placeholder="Enter phone"
            class="form-control"
          
          />
        </div>
        <!-- <div class="col-md-2">
          <label for=""> </label>
          <button
            (click)="openMobileModal(content2, adminPhone)"
            style="margin-top: 18%"
            class="btn-shadow align-items-center btn btn-success form-control"
          >
            <i class="fa fa-phone"></i> Update
          </button>
        </div> -->

        <div class="col-md-4">
          <label for="">Email </label>
          <input
            type="text"
            [(ngModel)]="adminEmail"
            placeholder="Enter email"
            class="form-control"
            
          />
        </div>
        <div class="col-md-2"></div>
      </div>

      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-4">
          <label for="">User Type </label>
          <input
            type="text"
            [(ngModel)]="adminUsertype"
            placeholder="Enter user type"
            class="form-control"
          />
        </div>
        <div class="col-md-4">
          <label for="">Source </label>
          <input
            type="text"
            [(ngModel)]="adminSource"
            placeholder="Enter source"
            class="form-control"
          />
        </div>
        <div class="col-md-2"></div>
      </div>

      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-4">
          <label for="">Ref. Code </label>
          <input
            type="text"
            [(ngModel)]="adminRefcode"
            placeholder="Enter ref. code"
            class="form-control"
          />
        </div>
        <div class="col-md-4">
          <label for="">Activation Status </label>
          <select
            name=""
            id=""
            [(ngModel)]="adminActivationstatus"
            class="form-control"
          >
            <option value="">Select Active Status</option>
            <option value="1">Active</option>
            <option value="0">Inactive</option>
          </select>
        </div>
        <div class="col-md-2"></div>
      </div>

      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-4">
          <label for="">KYC </label>
          <select name="" id="" [(ngModel)]="adminKyc" class="form-control">
            <option value="">Select Kyc Status</option>
            <option value="1">Approved</option>
            <option value="0">Pending</option>
            <option value="2">Reject</option>
          </select>
        </div>
        <div class="col-md-4">
          <label for="">Two factor Authentication </label>
          <select
            name=""
            id=""
            [(ngModel)]="adminTwofactor"
            class="form-control"
          >
            <option value="">Select Two Factor</option>
            <option value="1">Enable</option>
            <option value="0">Disable</option>
          </select>
        </div>
        <div class="col-md-2"></div>
      </div>

      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-4">
          <label for="">Is Phone Verified? </label>
          <select
            name=""
            id=""
            [(ngModel)]="adminIsphoneverfied"
            class="form-control"
          >
            <option value="">Select Phone Verification</option>
            <option value="1">Yes</option>
            <option value="0">No</option>
          </select>
        </div>
        <div class="col-md-4">
          <label for="">Ref By </label>
          <input
            type="text"
            [(ngModel)]="adminRefby"
            placeholder="Enter ref by"
            class="form-control"
          />
        </div>
        <div class="col-md-2"></div>
      </div>

      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-4">
          <label for="">IP Address </label>
          <input
            type="text"
            [(ngModel)]="adminIpaddress"
            placeholder="Enter ip address"
            class="form-control"
            readonly
          />
        </div>
        <div class="col-md-4">
          <label for="">Created On </label>
          <input
            type="text"
            [(ngModel)]="adminCreated"
            placeholder="Enter created on"
            class="form-control"
            readonly
          />
        </div>
        <div class="col-md-2"></div>
      </div>

      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-4">
          <label for="">Update user Active Status</label>
          <select name="" id="" [(ngModel)]="isDeleted" class="form-control">
            <!-- <option [ngValue]="0">Update user Active Status</option> -->
            <option [ngValue]="0">Active</option>
            <option [ngValue]="1">Inactive</option>
          </select>
        </div>
        <div class="col-md-2"></div>
      </div>

      <div class="row mt-2 mb-2 text-center">
        <div class="col-md-12">
          <button
            (click)="updateAdmin()"
            class="btn btn-primary btn-lg btn-block"
          >
            Update User
          </button>
        </div>
      </div>
    </div>
    <!-- <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="c('Close click')">Close</button>
                <button type="button" class="btn btn-primary">Save changes</button>
              </div> -->
  </ng-template>
  <!-- <button class="btn btn-primary" (click)="open(content5)">Launch demo modal</button> -->
</div>

<div class="card-body">
  <ng-template #content2 let-c="close" let-d="dismiss">
    <div class="modal-header">
      <h4 class="modal-title">
        <i class="fa fa-phone" aria-hidden="true"></i> Mobile Number Update
      </h4>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="d('Cross click')"
      ></button>
    </div>
    <div class="modal-body">
      <div class="row mb-2">
        <div class="col-md-2"></div>
        <div class="col-md-5">
          <label for="">New Mobile Number :</label>
          <input
            [(ngModel)]="newMobileNumber"
            type="text"
            class="form-control"
            placeholder="Enter new mobile number"
            maxlength="10"
          />
        </div>
        <div class="col-md-3">
          <button
            (click)="sendOTP()"
            class="btn btn-primary"
            style="margin-top: 18%"
            [disabled]="newMobileNumber.length != 10"
          >
            Send OTP
          </button>
        </div>
        <div class="col-md-2"></div>
      </div>

      <div *ngIf="isOTPSended" class="row mt-2 mb-2">
        <div class="col-md-2"></div>
        <div class="col-md-5">
          <label for="">One Time Password :</label>
          <input
            [(ngModel)]="otp"
            type="text"
            class="form-control"
            placeholder="Enter OTP"
          />
        </div>
        <div class="col-md-3">
          <button
            (click)="verifyOTP()"
            class="btn btn-primary"
            style="margin-top: 18%"
            [disabled]="otp == ''"
          >
            Verify OTP
          </button>
        </div>
        <div class="col-md-2"></div>
      </div>

      <!-- <div class="row mt-2 mb-2 text-center">
                   <div class="col-md-12">
                     <button (click)="updateAdmin()" class="btn btn-primary btn-lg btn-block">Update Admin </button>
                   </div>
                 </div>   -->
    </div>
    <!-- <div class="modal-footer">
                <button type="button" class="btn btn-secondary" (click)="c('Close click')">Close</button>
                <button type="button" class="btn btn-primary">Save changes</button>
              </div> -->
  </ng-template>
  <!-- <button class="btn btn-primary" (click)="open(content5)">Launch demo modal</button> -->
</div>
